/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllInvoices = (state) => values(get(state, ['invoices', 'items']));

export const requestingInvoices = (state) => (get(state, ['invoices', 'requesting']));

export const errorRequestingInvoices = (state) => get(state, ['invoices', 'error']);
